import * as React from 'react';
import { DataTableCell } from '@salesforce/design-system-react';

interface LinkCellProps extends React.HTMLAttributes<{}> {
	handleClick?: (item: {}) => void;
	item?: {}; 
}

const LinkCell: React.SFC<LinkCellProps> = ({ children, ...props }) => (
	<DataTableCell {...props}>
		<a 
			href="javascript:void(0);"
			onClick={(e) => { if (props.handleClick) { props.handleClick(props.item || {}); }}}
		>
			{children}
		</a>
	</DataTableCell>
);
LinkCell.displayName = DataTableCell.displayName;

export default LinkCell;


// WEBPACK FOOTER //
// ./src/lib/Overview/link-cell.tsx